import { render, staticRenderFns } from "./MembersUser.vue?vue&type=template&id=56e44b54&scoped=true"
import script from "./MembersUser.vue?vue&type=script&lang=js"
export * from "./MembersUser.vue?vue&type=script&lang=js"
import style0 from "./MembersUser.vue?vue&type=style&index=0&id=56e44b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e44b54",
  null
  
)

export default component.exports